/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInterestSettingsAppActionV2} from '../api'

 export const useQueryGetInterestSettingsAppActionV2 = createReactQueryHook('getInterestSettingsAppActionV2', getInterestSettingsAppActionV2)
